// Module
var code = "<div> <div class=\"name\">Activity Title</div> <template v-if=\"editing == true\"> <text-field :value.sync=\"filter.title\" label=\"Title\" help-text=\"String\"></text-field> </template> <template v-if=\"editing == false\"> Activity Title {{ operatorText }} \"<strong>{{ filter.title }}</strong>\" </template> </div> ";
// Exports
export default code;